<template>
  <div class="service-agreement">
    <!-- 页面头部 -->
    <div class="page-header">
      <van-nav-bar
        title="风险检测服务协议"
        left-text="返回"
        left-arrow
        @click-left="goBack"
      />
    </div>

    <!-- 协议内容 -->
    <div class="agreement-content">
      <div class="agreement-title">
        <h1>大数据分析用户协议</h1>
      </div>

      <div class="agreement-body">
        <section class="agreement-section">
          <p>如您勾选同意"大数据分析用户协议"将视为授权我们向合法的第三方支付机构/第三方征信机构/金融机构等(以下简称"第三方")提交您的信用査询申请, 本平台根据查询结果汇总生成您的相关信用数据报告。本协议已对与您的权益具有或可能具有重大关系的条款，及对公司具有或可能具有免责或限制责任的条款用粗体字予以标注，请您注意。</p>
        </section>

        <section class="agreement-section">
          <h3>一、接受条款</h3>
          <p>1.1 本平台的注册用户应当为持有中华人民共和国有效身份证件的18周岁以上且具有完全民事行为能力和民事权利能力的自然人。若您不具备前述主体资格，请勿使用服务，否则您应承担因此而导致的一切后果。如您违反前述注册限制而注册平台账户（包括您的账户，如有，下同）并使用了平台服务的，本平台有权随时中止或终止您的用户资格，并要求您的监护人承担连带责任。</p>
          <!-- <ul>
            <li>个人基本信息查询</li>
            <li>信贷记录查询</li>
            <li>公共记录查询</li>
            <li>查询记录查询</li>
          </ul> -->
          <p>1.2 本平台有权根据业务需要酌情修订本平台协议条款，并以平台系统公告的形式进行更新，不再另行通知您。请注意查看平台系统公告。经修订的条款一经在本平台公布，即产生效力。如您不同意相关修订请立即停止使用服务。如您继续使用服务，则视为您已完全接受经修订的条款，也将遵循修改后的本协议正文条款和平台规则使用平台的服务。</p>
          <p>1.3 本平台的协议内容包括本平台已经发布或将来要发布的各种规则或说明、产品提供方通过本平台发布的各种产品规则或说明，均是本协议的内容，如您不同意此项说明，请立即停止使用服务。如您继续使用服务，则视为您已完全接受平台的各种规则或说明。</p>
        </section>

        <section class="agreement-section">
          <h3>二、定义及解释</h3>
          <p>2.1 账户：指用户在本平台个人专属账户。</p>
          <p>2.2 人：指依照中国大陆地区（不含香港、台湾、澳门地区）法律具有民事权利能力的主体，包括自然人、法人和其他组织。</p>
          <p>2.3 中国法律：指中国宪法、法律、行政法规、部门规章、地方性法规、地方性政府部门规章以及由政府机构颁布的其他规范性文件。</p>
          <p>2.4 用户：如无特别说明，指符合本协议要求，使用本服务的自然人（“个人用户”）。</p>

          <p>2.5 信息提供者：指本平台向其采集用户信息的人和其他从其采集用户信息的渠道来源。</p>
          <p>2.6 “书面”或“书面形式”：如无特别说明或约定，纸质（或其他材质，例如电子书写板）函件、合同书、信件和数据电文、电报、电传、传真、电子数据交换、电子邮件、网络电子合同、网络授权函等可以有形地表现其所记载内容的形式均是书面形式。</p>
          <p>2.7 个人信用信息：是指对评价信息主体信用价值有关的各项信息，但是法律、法规或监管政策明确禁止采集的数据除外。</p>

          <p>2.8 不良信息：是指对信息主体信用状况构成负面影响的下列信息：信息主体在借贷、赊购、担保、租赁、保险、使用信用卡等活动中未按照合同履行义务的信息，对信息主体的违约信息，行政处罚信息，人民法院判决或者裁定信息主体履行义务、强制执行的信息，及国务院征信业监督管理部门规定的其他不良信息。</p>
        </section>

        <section class="agreement-section">
          <h3>三、采集授权</h3>
          <p>3.1 本人同意并不可撤销地授权本平台通过查询服务提供机构向包含但不限于中国人民银行征信中心及其分支机构以及其他信息服务机构查询并获取本人的个人信息，但不包括法律、行政法规规定禁止采集的个人信息。</p>
          <p>3.2 为更好、更完整地展现本人的资质情况，本人同意并授权本平台查询服务提供机构及其指定的第三方可留存、整理及加工本次获取的本人信息用于本平台查询服务提供机构及其指定的第三方为本人提供的其他服务中。</p>
          <p>3.3 本人已经知悉在信息安全保障制度不完善的情况下：对外提供个人收入、存款、有价证券、商业保险、不动产的信息和纳税数额信息可能产生信息泄漏等不良影响。所以在本平台及查询服务提供机构承诺保障本人信息安全的前提下，本人同意并不可撤销地授权本平台在法律法规许可范围内向查询服务提供机构提供这些信息。</p>
        </section>

        <section class="agreement-section">
          <h3>四、授权服务内容</h3>
          <p>4.1 获取本平台报告均需由本人授权查询，通过对授权的用户信息进行采集并向第三方提供该等用户信息或基于该等用户信息加工、整理所得结果。其中，“整理和加工”包括但不限于对用户信息的内容和/或形式进行重新排列、结构化、格式化、标准化等方法。汇总生成的信用报告,本平台有义务为您保密信用报告,在未经得您本人的授权同意的情况下不会向任何第三方泄露您的相关信息。</p>
          <p>4.2 您理解,为了给您提供客观、科学、全面的信用管理及评价,以及其他本协议项下服务的需要,您授权我们可以从合法保存或临时保存有您信息的第三方,采集及处理您的各类信息,同时为避免每次采集都需要经过您的反复确认而导致过程繁杂,或者因此给您带来的不便,您同意第三方可直接向我们提供您的信息而不需要您再次授权。采集您的信息包括但不限于您的个人信息、行为信息、交易信息、资产信息、设备信息等,目前采集后展示信息包括:运营商相关数据,实名核对、入网时长、号码归属地、 联系人黑名分析、 手机静默天数、互通号码个数、异常号码显示、活跃地区、夜间通话情况分析、半年通话消费账単、主/被叫次数、主/被叫分钟数、常联系人名单; 多平台申请借贷次数检测、多平台借贷是否有逾期(不会获取金额、放贷公司名称和借款记录)、是否被借贷平台列入黑名単、曾经申请借贷是否多次填错个人信息;公积金相关信息,个人客户号、姓名、身份证号、移动电话号码、电子邮箱(上述五项已带码不会获取全部信息)、公积金余额、缴纳时间;学信相关信息,姓名、身份证、学号(以上三项已带码不会获取全部信息)、学生照、性别、出生日期、民族、院校名称、所学专业、班级、学制、学历、入学及高校时间;京东数据,实名、认证身份证、绑定手机号、邮箱、收货人、地址、收货电话(上述七项已带码不会获取全部信息)、京东用户名、用户级别、用户昵称、性别、京东信用分等。您已经认识到您(作为个人用户)的收入、存款、有价证券、商业保险、不动产的信息和纳税数额信息对于您而言是相当私密而重要的。</p>
          <p>4.3 您同意我们向第三方采集并在适用的法律法规许可的范围内向信息使用者依法提供这些信息时,您已经充分理解并知院该等信息被提供和使用的风险。这些风险包括但不限于:纳入这些信息对您的信用评级(评分)、信用报告等结果可能产生的不利影响,该等信息被本平台依法提供给第三方后被他人不当利用的风险,因您的信用状况较好而造成您被第三方向您推销产品或服务等打扰的风险。</p>

          <p>4.4 您理解并同意,就征信服务而言,当第三方向我们查询您的相关信息时,该第三方应当获得您的事先授权同意并在约定范围使用。但是法律规定可以不经您授权即可查询的除外。因此,当您在相应场景下希望我们根据您的授权向第三方提供您的信息时,您应当向第三方做出清楚明确的授权,否则可能导致我们拒绝提供相应服务,或错误提供该等服务,因此可能会给您造成不利影响或损失。您充分理解并同意此结果的发生是由于您授权不清或不够明确导致,所以您将承担相应的后果。</p>
          <p>4.5您同意可直接向本平台提供信息的第三方包括但不限于:金融机构、类金融机构、电子商务公司、电信运营商、政府公共信用信息平台及事业单位等一切盈利性、非盈利性、公共、民间的机构及组织获取您授权查询的数据信息。同时我们向您承诺,我们不会采集您的宗教信仰、基因、指纹、血型、疾病和病史信息以及适用的法律法规禁止采集的任何个人信息,同时我们也不会采集您的聊天内容、短信内容、通话内容等个人信息,也不会采集、追踪您在社交媒体上的言论信息。</p>

          <p>4.6 您理解并同意,您应当对您的信息变动履行及时告知义务。若您的联系方式发生变化,及时通知本平台,否则由此带来的影响和损失,本平台不承担责任。</p>

        </section>

        <section class="agreement-section">
          <h3>五、保密条款</h3>
          <p>5.1 本平台重视对用户隐私的保护。因收集您的信息是出于遵守国家法律法规的规定以及向您提供服务及提升服务质量的目的,本平台对您的信用信息承担保密义务,不会为满足第三方的营销目的而向其出售或出租您的任何信息</p>
          <p>5.2 本平台会在下列情况下才将您的个人信用信息与第三方共享:</p>
          <ul>
            <li>5.2.1 事先获得用户的明确授权。</li>
            <li>5.2.2 某些情况下,只有共享您的信息,才能提供您需要的服务和(或)产品,或处理您与他人的交易纠纷或争议。</li>
            <li>5.2.3 某些服务和(或)产品由本平台的合作伙伴提供或由本平台与合作伙伴共同提供,本平台会与其共享提供服务和(或)产品需要的信息。</li>
            <li>5.2.4 本平台与第三方进行联合推广活动,本平台可能与其共享活动过程中产生的、为完成活动所必要的个人信息,如参加活动的中奖名単、中奖人联系方式等, 以便第三方能及时向您发放奖品 。</li>
            
            <li>5.2.5 为维护本平台和其他査询用户的合法权益。</li>
            <li>5.2.6 根据法律规定及合理商业习惯,在本平台计划与其他公司合并或被其收购或进行其他资本市场活动(包括但不限于债券发行)时,以及其他情形下本平台需要接受来自其他主体的尽职调查时,本平台会把您的信息提供给必要的主体,但本平台会通过和这些主体益署保密协议等方式要求其对您的个人信息采取合理的保密措施。根据有关的法律法规要求。</li>
            <li>5.2.7 按照相关政府主管部门的要求 。</li>
            
            <li>5.2.8 由于用户将其用户密码告知他人或与他人共享注册账户与密码, 由此导致的任何个人信息的世漏,或其他非因本平台原因导致用户个人信息的泄露。</li>
            <li>5.2.9 任何由于黑客攻击、电脑病毒入侵或其他不可抗力事件所导致的用户信息,、世露、 公开 。</li>
          </ul> 
        </section>

        <section class="agreement-section">
          <h3>六、服务限制及终止</h3>
          
          <p>6.1 您同意如您违反以下保证或发生相关情形,我们将有权限制或终止向您提供本协议项下的部分或全部服务。</p>
          <p>6.2 您是个人用户且向我们保证您已经年满18周岁, 并具备完全民事行为能力 。</p>
          <p>6.3 您不可以在任何时候将我们的服务用于任何非法目的, 比如侵害他人合法权益,或者以非法方式使用我们的服务。</p>
          <p>6.4 您保证,在我们为您提供服务期间,您向我们提供的所有资料和信息都是真实、完整、准确的并能够及时更新。为了保障为您提供有效完整的服务,您同意在我们发现您的身份存疑或涉嫌冒用他人身份信息时,有权基于保主户您及(或)其他第三方合理利益的需要,要求您配合补全或更新相关身份信息及资料。</p>

          <p>6.5 您保证,您不会授权他人使用我们的服务。比如您将使用本协议项下服务所需的载体,包括但不限于用于登录的账户、手机等披露或提供给其他人代替您操作、使用我们的服务。我们善意的提醒您,上述操作可能导致他人冒用您的身份使用本协议项下服务,因此给您造成损失或导致不良行为记录。</p>
          <p>6.6 如果我们认为您没有遵守本协议的约定,或者我们认为继续为您提供服务将会导致我们或第三方的合理利益受到损失。</p>
          <p>6.7 服务终止后, 为了后续异议或纠纷处理及未来查询相关信息的需要,从而保障我们及您的合法权益,您同意在服务終止后,我们仍可继续保留您使用我们的服务期间形成的所有信息和数据,但我们不会再主动采集您的任何信息。</p>
        </section>

        <section class="agreement-section">
          <h3>七、服务中断或故障</h3>
          <p>我们的系统在下列状况发生时会无法正常运作,所以下列情形中我们无法向您提供服务。您对此充分理解并同意我们无须就下述情况所导致服务无法正常提供时给您造成的各种影响或损失承担责任:</p>
          <ul>
            <li>7.1 我们公告的系统停机维护期间。</li>
            <li>7.2 电信设备出现故障不能进行数据传输的 。</li>
            <li>7.3 发生台风、地震、海口肃、洪水、停电、战争、恐怖袭击等事件造成我们系统障碍不能执行业务的。</li>
            <li>7.4 由于黑客攻击、电信部门技术调整或故障、网站升级、 第三方方面的l间题等原因而造成我们的服务中断或者延迟。</li>
        </ul>
        </section>

        <section class="agreement-section">
          <h3>八、责任限制</h3>
          <p>您理解, 如因您主动授权第三方查询您的信息,从而导致第三方拒绝向您提供服务或做出了对您不利的决定时,考虑到该信息的提供是由您自主同意提供的,您同意我们无须就此承担责任或赔偿。</p>
        </section>
        <section class="agreement-section">
          <h3>九、协议变更</h3>
          <p>作为本协议服务的提供方,我们将根据国家法律、法规及其他规范性文件的规定变化,增加、变更了新的服务类型或服务方式,进一步明确协议双方的权利义务的需要对本协议进行调整变更。同时, 您同意未来我们可以通过我们或合作伙伴的网站、客户端或其他适当的地方进行公布的方式通知您,而不需要另行単独通知您协议发生变更。您在本协议内容公告变更后继续使用本服务,表示您已充分阅读、 理解并接受变更后的协议内容;若您不同意修改后的协议内容, 您应停止使用本服务 。</p>
        </section>
        <section class="agreement-section">
          <h3>十、法律适用与管辖</h3>
          <p>本协议相关的所有问题均受到中国大陆法律管辖 。 如果因为本协议产生任何争议,您同意由本平台住所地人民法院管辖及裁决。</p>
        </section>
      </div>

      <!-- 协议底部 -->
      <div class="agreement-footer">
        <p class="update-time">最后更新时间：2024年1月1日</p>
        <p class="effective-time">生效时间：2024年1月1日</p>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="bottom-actions">
      <van-button type="primary" size="large" @click="agreeAndReturn">
        同意并返回
      </van-button>
    </div>
  </div>
</template>

<script>
import { NavBar } from 'vant';

export default {
  name: 'ServiceAgreement',
  components: {
    'van-nav-bar': NavBar
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    agreeAndReturn() {
      // 可以在这里处理同意协议的逻辑
      this.$toast('已同意服务协议');
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.service-agreement {
  min-height: 100vh;
  background: #f8f9fa;
  display: flex;
  flex-direction: column;
}

.page-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.agreement-content {
  flex: 1;
  padding: 0;
  background: white;
}

.agreement-title {
  text-align: center;
  padding: 30px 20px 20px;
}

.agreement-title h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
}

.agreement-body {
  padding: 20px;
  line-height: 1.6;
}

.agreement-section {
  margin-bottom: 25px;
}

.agreement-section h3 {
  color: #2c3e50;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 15px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid #e9ecef;
}

.agreement-section p {
  color: #555;
  font-size: 14px;
  line-height: 1.6;
  margin: 0 0 12px 0;
  text-align: justify;
}

.agreement-section ul {
  color: #555;
  font-size: 14px;
  line-height: 1.6;
  margin: 0 0 12px 0;
  padding-left: 20px;
}

.agreement-section li {
  margin-bottom: 6px;
}

.agreement-footer {
  padding: 20px;
  border-top: 1px solid #e9ecef;
  background: #f8f9fa;
  text-align: center;
}

.agreement-footer p {
  margin: 5px 0;
  color: #999;
  font-size: 12px;
}

.bottom-actions {
  padding: 15px 20px;
  background: white;
  border-top: 1px solid #e9ecef;
  position: sticky;
  bottom: 0;
}

.bottom-actions .van-button {
  width: 100%;
  border-radius: 25px;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .agreement-title {
    padding: 20px 15px 15px;
  }
  
  .agreement-title h1 {
    font-size: 18px;
  }
  
  .agreement-body {
    padding: 15px;
  }
  
  .agreement-section h3 {
    font-size: 15px;
  }
  
  .agreement-section p,
  .agreement-section ul {
    font-size: 13px;
  }
  
  .agreement-footer {
    padding: 15px;
  }
  
  .bottom-actions {
    padding: 12px 15px;
  }
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 4px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>